import React from "react";

function RigorouSecurity() {
  const reasons = [
    {
      icon: "fas fa-chart-line",
      title: "Custom Smart Contract Development",
      desc: "We create secure, flexible smart contracts tailored to your token’s requirements, ensuring smooth transactions and fair token allocation during the IDO.",
    },
    {
      icon: "fas fa-hand-holding-usd",
      title: "Rigorous Security Audits",
      desc: "Our team conducts in-depth audits, ensuring that all contracts and processes meet top security standards to protect investors and build trust in your project.",
    },
    {
      icon: "fas fa-exchange-alt",
      title: "Optimized Tokenomics Design",
      desc: "We work closely with you to design sustainable tokenomics that support long-term growth, integrating effective strategies for token allocation, liquidity, and investor incentives.",
    },
    {
      icon: "fas fa-coins",
      title: "Platform Integration & DEX Compatibility",
      desc: "Our development ensures compatibility with major DEXs, facilitating a smooth IDO launch and helping to build liquidity for your token on leading decentralized exchanges.",
    },
    {
      icon: "fas fa-building",
      title: "Comprehensive Marketing & Community Support",
      desc: "Beyond technical support, we provide marketing strategies and community-building services to drive awareness and engagement, creating a strong foundation for IDO success.",
    },
  ];

  return (
    <div style={{ padding: "80px 0", background: "#fff" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2
            className="fw-bold"
            style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}
          >
            Key Features & Functionalities of Our IDO Development Service
          </h2>
          {/* <p className="text-muted mx-auto" style={{ maxWidth: "700px", fontSize: "16px" }}>
            The crypto market has grown exponentially, and building your own exchange puts you at the center of a trillion-dollar industry.
          </p> */}
        </div>
        <div className="row g-4 justify-content-center">
          {reasons.map((item, idx) => (
            <div className="col-lg-4 col-md-6" key={idx}>
              <div className="ce-why-card">
                <div className="ce-why-icon">
                  <i className={item.icon}></i>
                </div>
                <div>
                  <h5
                    className="fw-bold mb-2"
                    style={{ color: "#0a1f44", fontSize: "17px" }}
                  >
                    {item.title}
                  </h5>
                  <p
                    className="mb-0 text-muted"
                    style={{ fontSize: "14px", lineHeight: "1.6" }}
                  >
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RigorouSecurity;
